import { IGetAllResponse } from '../../../components/util'
import { HttpRequest } from '../../../util/http'
import { userData } from '../../../util/userData'

export interface ISurveyResponse {
  data: ISurvey[]
  surveysToBeDeleted: string
}

export interface ISurvey {
  externalDataReference?: number
  interviewDate?: string
  abbr_survey?: string
  ai?: string
  organization?: string
  response?: any
  survey?: string
}

export const getSurveys = (filters = userData.getFilters()) => {
  const method = 'POST'
  const data: any = { ...filters }

  return HttpRequest.fetch<ISurveyResponse>('/scripts/admin/surveys/get_surveys', { data, method })
}

export const deleteClient = (deleteAlerts: boolean) => {
  const method = 'POST'
  const data = { deleteAlerts }

  return HttpRequest.fetch<ISurvey[]>('/scripts/admin/surveys/delete_client', { data, method })
}

export const deleteSelectedSurveys = (selectedSurveys: number[], deleteAlerts: boolean) => {
  const method = 'POST'
  const data = { selectedSurveys, deleteAlerts }

  return HttpRequest.fetch<ISurvey[]>('/scripts/admin/surveys/delete_surveys', { data, method })
}

